import React from 'react'

import { Body2, Bold, Heading2, Space } from '@gousto-internal/citrus-react'

import { LandingPageButton, TwoColumnLayout } from '../../../../components'
import cooking from '../assets/cooking.jpg'
import { EXPLORE_MENU } from './config'

import type { HowGoustoFoodBoxesWorkTypes } from '../../../../types'
import { MealPlanningSections, TargetUri, TrackingActions } from '../../../../types/tracking'

export function ExploreMenuSection({ startOnboarding }: HowGoustoFoodBoxesWorkTypes) {
  return (
    <TwoColumnLayout image={{ src: cooking, alt: EXPLORE_MENU.altText }}>
      <Heading2>{EXPLORE_MENU.headingLine1}</Heading2>
      <Space size={3} />
      <Body2 size={4}>
        With over 175 recipes to choose from every week,{' '}
        <Bold>Gousto has the biggest menu of any meal planning box out there.</Bold> Meaning there
        are more options for all tastes and dietary requirements. With our meal plans, you actually
        know what&apos;s for dinner before you&apos;re standing in front of the fridge at 7pm in a
        mild panic.
        <Space size={4} />
        We send you everything you need to whip up tasty dinners from scratch -{' '}
        <Bold>no last-minute supermarket dashes, no decision fatigue, no stress.</Bold> Just a menu
        that makes you feel like a mealtime mastermind, at a price that can&apos;t be beaten.
        <Space size={4} />
        <LandingPageButton
          startOnboarding={startOnboarding}
          sectionName={MealPlanningSections.EXPLORE_MENU}
          target={TargetUri.MENU}
          action={TrackingActions.CLICK_RECIPE_NAVIGATION}
        >
          {EXPLORE_MENU.ctaText}
        </LandingPageButton>{' '}
      </Body2>
      <Space size={6} />
    </TwoColumnLayout>
  )
}
